import ninegrid from "../index.js";
import { ngCellEx } from "./_ngCell.js";

class ngRowDrag extends ngCellEx
{
	constructor () {
		super();

		this.applyBaseStyle();

		ngRowDrag.scrollInterval = this.getAttribute("scroll-interval") || 300;
	}
	
	connectedCallback() {
		this.shadowRoot.innerHTML = `
		`;

		super.connectedCallback();
		
		this.cell.setAttribute("draggable", "true");
		
		this.cell.addEventListener("dragstart", this.#onDragStart);
	};
	
	dataRefresh = (v) => {
		//this.#target.innerHTML = this.getDisplayText();
		if (!v) this.reset();
	};
	
	#onDragStart = e => {

		const row = parseInt(this.cell.dataset.row);
		
		/**
		const cntr = this.owner.body.querySelectorAll(`.ng-container-left tr[data-row="${row}"]`);
		const colgroup = this.owner.body.querySelector(".ng-container-left colgroup");
		
		this.owner.body.querySelectorAll(`.ng-container-body colgroup col`).forEach(col => {
			//$(colgroup).append($(col).clone().addClass("ng-tmp"));
			$(colgroup).append(ninegrid.j.querySelectorAll(col.cloneNode(true)).addClass("ng-tmp").elem());
		});
		
		this.owner.body.querySelectorAll(`.ng-container-body tr[data-row="${row}"]`).forEach((tr,i) => {
			tr.querySelectorAll(`th,td`).forEach(cell => {
				//$(cntr[i]).append($(cell).clone().addClass("ng-tmp"));
				$(cntr[i]).append(ninegrid.j.querySelectorAll(cell.cloneNode(true)).addClass("ng-tmp").elem());
			});
		});
		
		this.owner.refreshData(row);
		*/
		
		const ghost = this.owner.body.querySelector(`.ng-container-body tr[data-row="${row}"]`);
		e.dataTransfer.setDragImage(ghost, 0, 0);
		e.dataTransfer.effectAllowed = "copyMove";
		
		ngRowDrag.dragData = {
			tr: this.cell.closest("tr"),
			id: this.owner.id,
			row: row,
			bind: this.cell.dataset.bind,
		}
	};
	
	//static sourceRow = -1;
	static dragData;
	static scrollInterval;
}


export class ngRowMover
{
	#owner;

	constructor (owner) {

		this.#owner	= owner;
		
		this.resetEvent();
	}
	
	/** attribute 변경에 대한 반응 */
	resetEvent = () => {

		//this.#ready = false;
		$(".ng-table tbody.bindable", this.#owner.body)
			.off("dragleave", this.#onDragLeave).off("dragenter", this.#onDragEnter).off("dragover", this.#onDragOver).off("drop", this.#onDrop).off("dragend", this.#onDragEnd)
			.on("dragleave", this.#onDragLeave).on("dragenter", this.#onDragEnter).on("dragover", this.#onDragOver).on("drop", this.#onDrop).on("dragend", this.#onDragEnd);
	}
	
	#borderTop = (row) => {
		[".ng-container-left",".ng-container-body",".ng-container-right"].forEach(group => {
			const trs = this.#owner.body.querySelectorAll(`${group} tr[data-row="${row}"]`);
			ninegrid.j.querySelectorAll("th,td", trs[0]).addClass("ng-dragover-up");
		});
	};

	#borderBottom = (row) => {
		[".ng-container-left",".ng-container-body",".ng-container-right"].forEach(group => {
			this.#owner.body.querySelectorAll(`${group} tr[data-row="${row}"]`).forEach((tr,i) => {
				tr.querySelectorAll("th,td").forEach(cell => {
					if ((i + (cell.rowSpan || 1)) == this.#owner.template.length) ninegrid.j.querySelectorAll(cell).addClass("ng-dragover-down");
				});
			});
		});
	};
	
	
	#onDragOver = e => {

		
		e.preventDefault();
		
		const sourceGrid= ngRowDrag.dragData.tr.getRootNode().host;
		const targetGrid= e.currentTarget.getRootNode().host;
		const sourceRow = parseInt(ngRowDrag.dragData.tr.dataset.row);
		const targetRow = parseInt(e.target.closest("th,td").dataset.row);


		ninegrid.j.querySelectorAll("th,td", sourceGrid.body).removeClass("ng-dragover-up").removeClass("ng-dragover-down");
		ninegrid.j.querySelectorAll("th,td", targetGrid.body).removeClass("ng-dragover-up").removeClass("ng-dragover-down");
		//ninegrid.j.querySelectorAll(`tr`, targetGrid.body).removeClass("ng-dragover-up").removeClass("ng-dragover-down");
		
		if (sourceGrid.id == targetGrid.id) {
			if (targetRow < sourceRow) {
				this.#borderTop(targetRow);
				ngRowDrag.dragData.targetRow = targetRow;
			}
			else if (targetRow > sourceRow) {
				this.#borderBottom(targetRow);
				ngRowDrag.dragData.targetRow = targetRow - 1;
			}
		}
		else {
			const tr = this.#owner.body.querySelector(`tr[data-row="${targetRow}"]`);//e.target.closest("tr");
			const y = e.pageY - $(tr).offset().top;
			const isUp = (y < (this.#owner.view.getRowHeight(targetRow) / 2)) ? true : false;

			(isUp) ? this.#borderTop(targetRow) : this.#borderBottom(targetRow);
			ngRowDrag.dragData.targetRow = isUp ? targetRow : targetRow + 1;
		}
	};
	
	#timer;
	#onDragEnter = e => {
		e.preventDefault();

		const row =parseInt(e.target.closest("tr").dataset.row);
		
		if ([this.#owner.view.getVisibleFirstRow(), this.#owner.view.getVisibleLastRow()].includes(row)) {
			setTimeout(() => {
				if (!this.#timer) {
					const by = row == this.#owner.view.getVisibleLastRow() ? 1 : -1;
					this.#timer = setInterval(() => {
						this.#owner.scrollBy(by);
					}, ngRowDrag.scrollInterval);
				}
			});
		}
	};
	
	#onDragLeave = e => {
		e.preventDefault();
		
		clearInterval(this.#timer);
		this.#timer = null;
	};
	
	#onDragEnd = e => {
		
	};
	
	#onDrop = e => {

		e.preventDefault();

		clearInterval(this.#timer);
		this.#timer = null;

		this.#owner.body.querySelectorAll(`.ng-container-left .ng-tmp`).forEach(el => {
			$(el).remove();
		});
		
		//ninegrid.j.querySelectorAll(`tr`, this.#owner.body).removeClass("ng-dragover-up").removeClass("ng-dragover-down");
		
		//const sourceGrid= document.getElementById(e.dataTransfer.getData("id"));
		//const sourceRow	= parseInt(e.dataTransfer.getData("row"));
		//const sourceBind= e.dataTransfer.getData("bind");
		const sourceGrid= ninegrid.nvl(document.getElementById(ngRowDrag.dragData.id), this.#owner);		/** Max Popup 화면에서 document.getElementById(ngRowDrag.dragData.id) == null */
		const sourceRow	= ngRowDrag.dragData.row;
		const sourceBind= ngRowDrag.dragData.bind;
		
		//if (!sourceGrid) return;
		
		const targetTr	= e.target.closest("tr");
		const targetGrid= e.target.getRootNode().host;
		const targetRow	= parseInt(targetTr.dataset.row);
		const targetBind= targetGrid.body.querySelector("ng-row-drag") ? targetGrid.body.querySelector("ng-row-drag").cell.dataset.bind : null;

		ninegrid.j.querySelectorAll("th,td", sourceGrid.body).removeClass("ng-dragover-up").removeClass("ng-dragover-down");
		ninegrid.j.querySelectorAll("th,td", targetGrid.body).removeClass("ng-dragover-up").removeClass("ng-dragover-down");
		
		if (sourceGrid.id == targetGrid.id && sourceRow == targetRow) return;
		
		const canEvent	= new CustomEvent(ninegrid.EVENT.CAN_ROW_MOVE, { bubbles: true, cancelable: true, detail: {} });
		canEvent.sourceGrid	= sourceGrid;
		canEvent.targetGrid	= targetGrid;
		canEvent.sourceRow	= sourceRow;
		canEvent.targetRow	= ngRowDrag.dragData.targetRow;//targetRow;



		if (this.#owner.dispatchEvent(canEvent)) {
			
			if (sourceGrid.id == targetGrid.id) {
				(e.altKey) ? this.#owner.data.insert(this.#owner.data.get(sourceRow), targetRow) : this.#owner.data.moveRow(sourceRow, targetRow);
			}
			else {
				/**
				 * 1. insert
				 * 2. altKey : delete
				 */
				targetGrid.data.insert(sourceGrid.data.get(sourceRow), ngRowDrag.dragData.targetRow);
				if (!e.altKey) sourceGrid.data.delete(sourceRow);
			}
		}
		
		if (sourceBind) {
			const COL_IDX = sourceGrid.fields.indexOf(sourceBind);
			
			for (var i = 0; i < sourceGrid.data.all.count(); i++) {
				sourceGrid.data.all.setRecord(i, COL_IDX, i+1);
			};
		}
		if (targetBind && sourceGrid.id != targetGrid.id) {
			const COL_IDX = targetGrid.fields.indexOf(targetBind);
			
			for (var i = 0; i < targetGrid.data.all.count(); i++) {
				targetGrid.data.all.setRecord(i, COL_IDX, i+1);
			};
		}
		
		this.#owner.dataManager.viewRecords.reset();
		
		const doneEvent	= new CustomEvent(ninegrid.EVENT.ROW_MOVED, { bubbles: true, detail: {} });
		doneEvent.sourceGrid= sourceGrid;
		doneEvent.targetGrid= targetGrid;
 		doneEvent.sourceRow	= sourceRow;
 		doneEvent.targetRow	= ngRowDrag.dragData.targetRow;//targetRow;
		
		this.#owner.dispatchEvent(doneEvent);
		
		ngRowDrag.dragData = null;
	};
}

if (!customElements.get('ng-row-drag')) {
	customElements.define("ng-row-drag", ngRowDrag);
}


